import React, { ReactElement } from 'react'
import { getTermHeader } from '@/domain/term/headerMappings/getTermHeader'
import { CustomHeaderType } from '@/domain/term/headerMappings/constants'
import { TAXONOMY_ROUTES } from '../../domain/term/constants'
import { getLocationSlugFromUrl } from '@/utils/getLocationSlugFromUrl'
import type { PageType } from '@/types/models'
import {
  isFacetPageType,
  isLocationPageType
} from '@/domain/useCases/pageTypeCheck'

export const NearbyFeedHeader = ({
  title,
  customTermHeader,
  pageType,
  termData,
  shouldDefaultRegionalize = false
}: {
  title: string
  pageType: PageType
  termData
  customTermHeader?: string
  shouldDefaultRegionalize?: boolean
}): ReactElement => {
  const nearbyFeedHeader = getTermHeader({
    pageType,
    title,
    termTitle: termData.title,
    customTermHeader,
    shouldDefaultRegionalize,
    headerType: CustomHeaderType.NEARBY_FEED
  })
  const nearbyFeedHeaderSplitted = nearbyFeedHeader.split(title)
  const termPhrase = nearbyFeedHeaderSplitted[1]
    ? nearbyFeedHeaderSplitted[1].replace(termData.title, '')
    : ''

  return (
    <div
      className="-mb-6 pb-4 pt-8 text-lg font-normal text-gray-900 md:-mb-8"
      key="nearby-header"
    >
      {isFacetPageType(pageType) && (
        <>
          <a
            className="text-lg font-semibold text-gray-1100 underline hover:underline md:no-underline"
            href={
              termData.slug.includes('luxury')
                ? '/luxury/'
                : `/${TAXONOMY_ROUTES[pageType]}/${termData.slug}/`
            }
          >
            {customTermHeader ?? `${termPhrase} ${termData.title}`}
          </a>{' '}
          near{' '}
        </>
      )}

      {isLocationPageType(pageType) && (
        <>
          <span>{shouldDefaultRegionalize ? 'Centres' : 'Centers'} Near</span>{' '}
        </>
      )}

      <a
        className="text-lg font-semibold text-gray-1100 underline hover:underline md:no-underline"
        href={`/${getLocationSlugFromUrl(title)}/`}
      >
        {title}
      </a>
    </div>
  )
}

export default NearbyFeedHeader
